var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.896,
    height: 19.387,
    viewBox: "0 0 15.896 19.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.057-58.689H22.37a3,3,0,0,0,3.292-3.292v-7.81a3.948,3.948,0,0,0-1.237-3.314l-3.7-3.734a3.952,3.952,0,0,0-3.281-1.237H13.057a3,3,0,0,0-3.292,3.3v12.792A2.99,2.99,0,0,0,13.057-58.689Zm.4-2.817c-.608,0-.862-.3-.862-.873v-12c0-.585.254-.873.873-.873h3.071v3.7c0,1.79.84,2.618,2.629,2.618h3.667v6.551a.76.76,0,0,1-.873.873Zm5.888-9.633a.524.524,0,0,1-.6-.585v-3.4l3.966,3.988Zm.961,4.021H15.068a.6.6,0,0,0-.63.608.607.607,0,0,0,.63.619H20.3a.6.6,0,0,0,.619-.619A.6.6,0,0,0,20.3-67.118Zm0,2.485H15.068a.613.613,0,0,0-.63.619.6.6,0,0,0,.63.608H20.3a.6.6,0,0,0,.619-.608A.611.611,0,0,0,20.3-64.633Z",
    transform: "translate(-9.766 78.076)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.e5f730b81ab458b4ae85335aff4edc13.svg";
export { ForwardRef as ReactComponent };